<template>
<div>
    <div class="modal fade bd-example-modal-lg" tabindex="-1" role="dialog" id="selectedUsersModal">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <table class="table">
                    <thead>
                        <tr>
                            <td>#</td>
                            <td>Nome</td>
                            <td>Empresa</td>
                            <td>Unidade</td>
                            <td>Setor</td>
                            <td>Cargo</td>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="user in selectedUsersTotal" :key="user.id">
                            <td>{{ user.id }}</td>
                            <td>{{ user.name }}</td>
                            <td>{{ user.company.name }}</td>
                            <td>{{ user.branch.name }}</td>
                            <td>{{ user.sector.name }}</td>
                            <td>{{ user.role.name }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="ibox animated fadeInRightBig">
        <div class="ibox-title" style="padding:5px;">
            <h5>Lote de Assinaturas</h5>
        </div>
        <div class="ibox-content" style="position: relative">
            <div class="row">
                <div class="col-md-3">
                    <label>Nome</label>
                    <input type="text" class="form-control" v-model="batch.name" />
                </div>
                <div class="col-md-3">
                    <label>Data limite para assinatura</label>
                    <date-picker :only-date="true" v-model="batch.limit_date" :output-format="'YYYY-MM-DD'" :format="'YYYY-MM-DD'" :formated="'YYYY-MM-DD'" :auto-close="true" :button-now-translation="'Hoje'" :label="''" :color="'#03a830'"></date-picker>
                </div>
                <div class="col-md-3">
                    <label>Documento</label>
                    <select class="form-control" v-model="batch.signature_document_id">
                        <option :value="signatureDocument.id" v-for="signatureDocument in signatureDocuments" :key="signatureDocument.id">{{ signatureDocument.name }}</option>
                    </select>
                </div>
                <div class="col-md-3">
                    <label>Grupo de Visualização</label>
                    <select class="form-control" v-model="batch.viewing_group_id">
                        <option :value="viewing_group.id" v-for="viewing_group in viewing_groups" :key="viewing_group.id">{{ viewing_group.name }}</option>
                    </select>
                </div>
            </div>
            <br>
            <div class="row">
                <div class="col-md-3">
                    <input type="checkbox" v-model="onlyActives"> Enviar <b>APENAS</b> para usuários ativos
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <hr class="mt-5" />
                    <h5>
                        <b>Passo 1:</b> Selecione as
                        <b>Empresas</b>
                    </h5>
                    <div class="row">
                        <div class="col-md-6">
                            <button class="btn btn-success btn-block mb-2" @click="moveAll('companies', 'availableCompanies', 'selectedCompanies')">
                                <span class="badge badge-light">{{ availableCompanies.length }}</span> Mover todas >>
                            </button>
                            <input type="text" placeholder="Procurar..." class="form-control mb-2" v-model="companies_search" />
                            <ul class="list-group entity-filter-selection">
                                <li class="list-group-item" v-for="company in availableCompanies" :key="company.id" @click="itemSelected(company, 'companies', 'selectedCompanies')">{{ company.fantasy_name }}</li>
                            </ul>
                        </div>
                        <div class="col-md-6">
                            <button class="btn btn-success btn-block mb-2" @click="moveAll('selectedCompanies', 'selectedCompanies', 'companies')">
                                << Mover todas <span class="badge badge-light">{{ selectedCompaniesFiltered.length }}</span>
                            </button>
                            <input type="text" placeholder="Procurar..." class="form-control mb-2" v-model="companies_selected_search" />
                            <ul class="list-group entity-filter-selection">
                                <li class="list-group-item" v-for="selectedCompany in selectedCompaniesFiltered" :key="selectedCompany.id" @click="itemSelected(selectedCompany, 'selectedCompanies', 'companies')">{{ selectedCompany.fantasy_name }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <hr class="mt-5" />
                    <h5>
                        <b>Passo 2:</b> Selecione as
                        <b>Unidades</b>
                    </h5>
                    <div class="row">
                        <div class="col-md-6">
                            <button class="btn btn-success btn-block mb-2" @click="moveAll('branches', 'availableBranches', 'selectedBranches')">
                                <span class="badge badge-light">{{ availableBranches.length }}</span> Mover todas >>
                            </button>
                            <input type="text" placeholder="Procurar..." class="form-control mb-2" v-model="branches_search" />
                            <ul class="list-group entity-filter-selection">
                                <li class="list-group-item" v-for="branch in availableBranches" :key="branch.id" @click="itemSelected(branch, 'branches', 'selectedBranches')">{{ branch.name }}</li>
                            </ul>
                        </div>
                        <div class="col-md-6">
                            <button class="btn btn-success btn-block mb-2" @click="moveAll('selectedBranches', 'selectedBranches', 'branches')">
                                << Mover todas <span class="badge badge-light">{{ selectedBranchesFiltered.length }}</span>
                            </button>
                            <input type="text" placeholder="Procurar..." class="form-control mb-2" v-model="branches_selected_search" />
                            <ul class="list-group entity-filter-selection">
                                <li class="list-group-item" v-for="selectedBranch in selectedBranchesFiltered" :key="selectedBranch.id" @click="itemSelected(selectedBranch, 'selectedBranches', 'branches')">{{ selectedBranch.name }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <hr class="mt-5" />
                    <h5>
                        <b>Passo 3:</b> Selecione os
                        <b>Departamentos</b>
                    </h5>
                    <div class="row">
                        <div class="col-md-6">
                            <button class="btn btn-success btn-block mb-2" @click="moveAll('sectors', 'availableSectors', 'selectedSectors')">
                                <span class="badge badge-light">{{ availableSectors.length }}</span> Mover todas >>
                            </button>
                            <input type="text" placeholder="Procurar..." class="form-control mb-2" v-model="sectors_search" />
                            <ul class="list-group entity-filter-selection">
                                <li class="list-group-item" v-for="sector in availableSectors" :key="sector.id" @click="itemSelected(sector, 'sectors', 'selectedSectors')">{{ sector.name }}</li>
                            </ul>
                        </div>
                        <div class="col-md-6">
                            <button class="btn btn-success btn-block mb-2" @click="moveAll('selectedSectors', 'selectedSectors', 'sectors')">
                                << Mover todas <span class="badge badge-light">{{ selectedSectorsFiltered.length }}</span>
                            </button>
                            <input type="text" placeholder="Procurar..." class="form-control mb-2" v-model="sectors_selected_search" />
                            <ul class="list-group entity-filter-selection">
                                <li class="list-group-item" v-for="selectedSector in selectedSectorsFiltered" :key="selectedSector.id" @click="itemSelected(selectedSector, 'selectedSectors', 'sectors')">{{ selectedSector.name }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <hr class="mt-5" />
                    <h5>
                        <b>Passo 4:</b> Selecione os
                        <b>Cargos</b>
                    </h5>
                    <div class="row">
                        <div class="col-md-6">
                            <button class="btn btn-success btn-block mb-2" @click="moveAll('roles', 'availableRoles', 'selectedRoles')">
                                <span class="badge badge-light">{{ availableRoles.length }}</span> Mover todas >>
                            </button>
                            <input type="text" placeholder="Procurar..." class="form-control mb-2" v-model="roles_search" />
                            <ul class="list-group entity-filter-selection">
                                <li class="list-group-item" v-for="role in availableRoles" :key="role.id" @click="itemSelected(role, 'roles', 'selectedRoles')">{{ role.name }}</li>
                            </ul>
                        </div>
                        <div class="col-md-6">
                            <button class="btn btn-success btn-block mb-2" @click="moveAll('selectedRoles', 'selectedRoles', 'roles')">
                                << Mover todas <span class="badge badge-light">{{ selectedRolesFiltered.length }}</span>
                            </button>
                            <input type="text" placeholder="Procurar..." class="form-control mb-2" v-model="roles_selected_search" />
                            <ul class="list-group entity-filter-selection">
                                <li class="list-group-item" v-for="selectedRole in selectedRolesFiltered" :key="selectedRole.id" @click="itemSelected(selectedRole, 'selectedRoles', 'roles')">{{ selectedRole.name }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <hr class="mt-5" />
                    <h5>
                        <b>Passo 5:</b> Selecione os
                        <b>Usuários</b>
                    </h5>
                    <div class="row">
                        <div class="col-md-6">
                            <button class="btn btn-success btn-block mb-2" @click="moveAll('users', 'availableUsers', 'selectedUsers')">
                                <span class="badge badge-light">{{ availableUsers.length }}</span> Mover todos >>
                            </button>
                            <input type="text" placeholder="Procurar..." class="form-control mb-2" v-model="users_search" />
                            <ul class="list-group entity-filter-selection">
                                <li class="list-group-item" v-for="user in availableUsers" :key="user.id" @click="itemSelected(user, 'users', 'selectedUsers')">{{ user.name }}</li>
                            </ul>
                        </div>
                        <div class="col-md-6">
                            <button class="btn btn-success btn-block mb-2" @click="moveAll('selectedUsers', 'selectedUsers', 'users')">
                                << Mover todos <span class="badge badge-light">{{ selectedUsers.length }}</span>
                            </button>
                            <input type="text" placeholder="Procurar..." class="form-control mb-2" v-model="users_selected_search" />
                            <ul class="list-group entity-filter-selection">
                                <li class="list-group-item" v-for="selectedUser in selectedUsersFiltered" :key="selectedUser.id" @click="itemSelected(selectedUser, 'selectedUsers', 'users')">{{ selectedUser.name }}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <hr class="mt-5" />
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        <b>Passo 6:</b> Escreva o
                        <b>Texto do E-mail</b>
                    </h5>

                    <h3 class="mt-5">Olá, {nome_do_colaborador}</h3>
                    <textarea rows="10" class="form-control" v-model="batch.email_text"></textarea>
                </div>
            </div>
            <div class="row mt-5 mb-5">
                <div class="col-md-12 float-right">
                    <div class="form-page__footer">
                      <div class="form-page__actions">
                        <router-link :to="'/signatureBatches'" class="btn btn-return">
                          <i class="fa fa-arrow-left"></i> Voltar
                        </router-link>
                        <button class="btn btn-add" @click="save">
                          <i class="fa fa-save"></i> Salvar
                        </button>
                      </div>
                    </div>
                </div>
            </div>
            <div class="float-selected-users">
                <button class="btn" @click="selectedUsersTotalClicked">Usuários selecionados: {{ selectedUsersTotal.length }}</button>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            batch: {
                name: "",
                signature_document_id: "",
                email_text: "",
                limit_date: ""
            },
            onlyActives: false,
            viewing_groups: [],
            signatureDocuments: [],
            companies: [],
            branches: [],
            sectors: [],
            roles: [],
            users: [],
            selectedCompanies: [],
            selectedBranches: [],
            selectedSectors: [],
            selectedRoles: [],
            selectedUsers: [],
            companies_search: "",
            branches_search: "",
            sectors_search: "",
            roles_search: "",
            users_search: "",
            companies_selected_search: "",
            branches_selected_search: "",
            sectors_selected_search: "",
            roles_selected_search: "",
            users_selected_search: "",
            selectedUsersTotal: []
        };
    },
    computed: {
        availableCompanies() {
            const self = this;
            if (self.selectedCompanies.length >= 0) {
                return self.companies.filter(company => {
                    let isSelected = self.selectedCompanies.find(
                        selectedCompany => selectedCompany.id == company.id
                    );

                    let matches = true;
                    if (self.companies_search) {
                        let companies_search_under = self.companies_search.toLowerCase();
                        let company_under = company.fantasy_name.toLowerCase();
                        matches = company_under.includes(companies_search_under);
                    }

                    if (!isSelected && matches) {
                        return true;
                    } else {
                        return false;
                    }
                });
            }
            return [];
        },
        availableBranches() {
            const self = this;
            if (self.selectedCompanies.length) {
                return self.branches.filter(branch => {
                    let companySelected = self.selectedCompanies.find(
                        company => company.id == branch.company_id
                    );
                    let isSelected = self.selectedBranches.find(
                        selectedBranch => selectedBranch.id == branch.id
                    );

                    let matches = true;
                    if (self.branches_search) {
                        let branches_search_under = self.branches_search.toLowerCase();
                        let branch_under = branch.name.toLowerCase();
                        matches = branch_under.includes(branches_search_under);
                    }

                    if (companySelected && !isSelected && matches) {
                        return true;
                    } else {
                        return false;
                    }
                });
            }
            return [];
        },
        availableSectors() {
            const self = this;
            if (self.selectedBranches.length) {
                return self.sectors.filter(sector => {
                    let branchSelected = self.selectedBranches.find(
                        branch => branch.id == sector.branch_id
                    );
                    let isSelected = self.selectedSectors.find(
                        selectedSector => selectedSector.id == sector.id
                    );

                    let matches = true;
                    if (self.sectors_search) {
                        let sectors_search_under = self.sectors_search.toLowerCase();
                        let sector_under = sector.name.toLowerCase();
                        matches = sector_under.includes(sectors_search_under);
                    }

                    if (branchSelected && !isSelected && matches) {
                        return true;
                    } else {
                        return false;
                    }
                });
            }
            return [];
        },
        availableRoles() {
            const self = this;
            if (self.selectedSectors.length) {
                return self.roles.filter(role => {
                    let sectorSelected = self.selectedSectors.find(
                        sector => sector.id == role.sector_id
                    );
                    let isSelected = self.selectedRoles.find(
                        selectedRole => selectedRole.id == role.id
                    );

                    let matches = true;
                    if (self.roles_search) {
                        let roles_search_under = self.roles_search.toLowerCase();
                        let role_under = role.name.toLowerCase();
                        matches = role_under.includes(roles_search_under);
                    }

                    if (sectorSelected && !isSelected && matches) {
                        return true;
                    } else {
                        return false;
                    }
                });
            }
            return [];
        },
        availableUsers() {
            const self = this;
            if (self.selectedRoles.length) {
                return self.users
                    .filter(user => {
                        let rolesSelected = self.selectedRoles.find(
                            role => role.id == user.role_id
                        );
                        let isSelected = self.selectedUsers.find(
                            selectedUser => selectedUser.id == user.id
                        );

                        let matches = true;
                        if (self.users_search) {
                            let users_search_under = self.users_search.toLowerCase();
                            let user_under = user.name.toLowerCase();
                            matches = user_under.includes(users_search_under);
                        }

                        if (rolesSelected && !isSelected && matches) {
                            return true;
                        } else {
                            return false;
                        }
                    })
                    .sort((a, b) => {
                        if (a.name > b.name) return 1;
                        if (b.name > a.name) return -1;

                        return 0;
                    });
            }
            return [];
        },
        selectedCompaniesFiltered() {
            const self = this;
            return self.selectedCompanies.filter(company => {
                let matches = true;
                if (self.companies_selected_search) {
                    let companies_selected_search_under = self.companies_selected_search.toLowerCase();
                    let company_under = company.fantasy_name.toLowerCase();
                    matches = company_under.includes(companies_selected_search_under);
                }

                if (matches) {
                    return true;
                } else {
                    return false;
                }
            });
        },
        selectedBranchesFiltered() {
            const self = this;
            return self.selectedBranches.filter(branch => {
                let matches = true;
                if (self.branches_selected_search) {
                    let branches_selected_search_under = self.branches_selected_search.toLowerCase();
                    let branch_under = branch.name.toLowerCase();
                    matches = branch_under.includes(branches_selected_search_under);
                }

                if (matches) {
                    return true;
                } else {
                    return false;
                }
            });
        },
        selectedSectorsFiltered() {
            const self = this;
            return self.selectedSectors.filter(sector => {
                let matches = true;
                if (self.sectors_selected_search) {
                    let sectors_selected_search_under = self.sectors_selected_search.toLowerCase();
                    let sector_under = sector.name.toLowerCase();
                    matches = sector_under.includes(sectors_selected_search_under);
                }

                if (matches) {
                    return true;
                } else {
                    return false;
                }
            });
        },
        selectedRolesFiltered() {
            const self = this;
            return self.selectedRoles.filter(role => {
                let matches = true;
                if (self.roles_selected_search) {
                    let roles_selected_search_under = self.roles_selected_search.toLowerCase();
                    let role_under = role.name.toLowerCase();
                    matches = role_under.includes(roles_selected_search_under);
                }

                if (matches) {
                    return true;
                } else {
                    return false;
                }
            });
        },
        selectedUsersFiltered() {
            const self = this;
            return self.selectedUsers.filter(user => {
                let matches = true;
                if (self.users_selected_search) {
                    let users_selected_search_under = self.users_selected_search.toLowerCase();
                    let user_under = user.name.toLowerCase();
                    matches = user_under.includes(users_selected_search_under);
                }

                if (matches) {
                    return true;
                } else {
                    return false;
                }
            });
        }
    },
    methods: {
        moveAll(actualFrom, from, to) {
            const self = this;
            while (self[from].length) {
                let item = self[from][0];
                let foundItem = self[actualFrom].find(
                    actualFromItem => actualFromItem.id == item.id
                );
                self.itemSelected(foundItem, actualFrom, to);
            }
        },
        itemSelected(remove, from, to) {
            let add = this.removeItem(from, remove);
            if (add) {
                this.addItem(to, add);
            }
        },
        removeItem(from, remove) {
            let foundIndex = this[from].findIndex(item => item.id == remove.id);
            if (foundIndex !== null) {
                return this[from].splice(foundIndex, 1)[0];
            }
        },
        addItem(to, add) {
            this[to].push(add);
        },
        makeFormData() {
            const fd = new FormData();
            console.log(fd);
            fd.append("name", this.batch.name);
            fd.append("signature_document_id", this.batch.signature_document_id);
            fd.append("email_text", this.batch.email_text);
            fd.append("limit_date", this.batch.limit_date);
            fd.append("viewing_group_id", this.batch.viewing_group_id ? this.batch.viewing_group_id : '');
            this.onlyActives ? fd.append("onlyActives", 1) : fd.append("onlyActives", 0);

            this.selectedCompanies.forEach(selectedCompany => {
                fd.append("companies[]", selectedCompany.id);
            });

            this.selectedBranches.forEach(selectedBranch => {
                fd.append("branches[]", selectedBranch.id);
            });

            this.selectedSectors.forEach(selectedSector => {
                fd.append("sectors[]", selectedSector.id);
            });

            this.selectedRoles.forEach(selectedRole => {
                fd.append("roles[]", selectedRole.id);
            });

            this.selectedUsers.forEach(selectedUser => {
                fd.append("users[]", selectedUser.id);
            });

            const id = this.$route.params.id;
            if (id) {
                fd.append("id", id);
                fd.append("_method", "PUT");
            }

            console.log(fd);

            return fd;
        },
        save() {
            $("#page_loader").show();

            const self = this;
            let api = self.$store.state.api + "signaturebatches";

            const id = this.$route.params.id;
            if (id) {
                api += "/" + id;
            }

            const fd = self.makeFormData();

            console.log(fd);

            self.$http
                .post(api, fd)
                .then(response => {
                    self.$message(
                        "Sucesso",
                        "Lote de assinaturas criado com sucesso",
                        "success"
                    );
                    self.$router.push("/signatureBatches");
                    $("#page_loader").hide();
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                    $("#page_loader").hide();
                });
        },
        getBatch(id) {
            const self = this;
            const api =
                self.$store.state.api +
                "signaturebatches/" +
                id +
                "?with[]=companies&with[]=branches&with[]=sectors&with[]=roles&with[]=users";
            self.$http
                .get(api)
                .then(response => {
                    self.batch = response.data.data[0];

                    self.selectedCompanies = response.data.data[0].companies;
                    self.selectedBranches = response.data.data[0].branches;
                    self.selectedSectors = response.data.data[0].sectors;
                    self.selectedRoles = response.data.data[0].roles;
                    self.selectedUsers = response.data.data[0].users;
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        },
        getSignatureDocuments() {
            const self = this;
            const api = self.$store.state.api + "signaturedocuments/?paginated=false";
            self.$http
                .get(api)
                .then(response => {
                    self.signatureDocuments = response.data.data;
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        },
        getCompanies() {
            const self = this;
            const api = self.$store.state.api + "companies/?paginated=false";
            self.$http
                .get(api)
                .then(response => {
                    self.companies = response.data.data;
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        },
        getBranches() {
            const self = this;
            const api = self.$store.state.api + "branches/?paginated=false";
            self.$http
                .get(api)
                .then(response => {
                    self.branches = response.data.data;
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        },
        getSectors() {
            const self = this;
            const api = self.$store.state.api + "sectors/?paginated=false";
            self.$http
                .get(api)
                .then(response => {
                    self.sectors = response.data.data;
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        },
        getRoles() {
            const self = this;
            const api = self.$store.state.api + "roles/?paginated=false";
            self.$http
                .get(api)
                .then(response => {
                    self.roles = response.data.data;
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        },
        getUsers() {
            const self = this;
            if(self.onlyActives == true){
                var onlyAblesApi = "&disabled=0"
            } else {
                var onlyAblesApi = ""
            }
            console.log(onlyAblesApi);
            const api = self.$store.state.api + "users/?paginated=false" + onlyAblesApi;
            self.$http
                .get(api)
                .then(response => {
                    self.users = response.data.data;
                    console.log(self.users);
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        },
        getViewingGroups() {
            const self = this;
            const api = self.$store.state.api + "signature_viewing_groups?paginated=false";
            self.$http
                .get(api)
                .then(response => {
                    self.viewing_groups = response.data.data;
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        },
        getSelectedUsersTotal() {
            const self = this;
            const api = self.$store.state.api + "signaturebatches/selectedUsersTotal";

            const fd = new FormData();
            self.selectedCompanies.forEach((selectedCompany, index) => {
                fd.append("companies[" + index + "]", selectedCompany.id);
            });
            self.selectedBranches.forEach((selectedBranch, index) => {
                fd.append("branches[" + index + "]", selectedBranch.id);
            });
            self.selectedSectors.forEach((selectedSector, index) => {
                fd.append("sectors[" + index + "]", selectedSector.id);
            });
            self.selectedRoles.forEach((selectedRole, index) => {
                fd.append("roles[" + index + "]", selectedRole.id);
            });
            self.selectedUsers.forEach((selectedUser, index) => {
                fd.append("users[" + index + "]", selectedUser.id);
            });

            fd.append("onlyActives", self.onlyActives);

            self.$http
                .post(api, fd)
                .then(response => {
                    self.selectedUsersTotal = response.data;
                })
                .catch(error => {
                    self.$message("Erro", error.response.data, "error");
                });
        },
        selectedUsersTotalClicked() {
            $("#selectedUsersModal").modal("show");
        }
    },
    watch: {
        onlyActives: function() {
            this.getUsers();
            this.getSelectedUsersTotal();
        },
        availableCompanies: function () {
            this.getSelectedUsersTotal();
        },
        availableBranches: function () {
            this.getSelectedUsersTotal();
        },
        availableSectors: function () {
            this.getSelectedUsersTotal();
        },
        availableRoles: function () {
            this.getSelectedUsersTotal();
        },
        availableUsers: function () {
            this.getSelectedUsersTotal();
        }
    },
    mounted: function () {
        const id = this.$route.params.id;
        if (id) {
            this.getBatch(id);
        }
        this.getSignatureDocuments();
        this.getCompanies();
        this.getBranches();
        this.getSectors();
        this.getRoles();
        this.getUsers();
        this.getViewingGroups();
    }
};
</script>



// WEBPACK FOOTER //
// src/components/SignatureBatch/SignatureBatch.vue